import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import styles from "./styles/Browse.module.css";
import ScenarioCard from "../mainlayout/body/ScenarioCard";
import axios from 'axios';
import Loading from "../loading/Loading";

const Browse = () => {
    const { tag } = useParams();
    const [scenarios, setScenarios] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        const fetchScenarios = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_URL_LOCAL}/api/scenarios/search/tags?tag=${tag}`
                );
                setScenarios(response.data);
                setIsLoading(false);
            } catch (error) {
                setIsLoading(false);
                console.error(`Error: ${error}`);
            }
        };
        fetchScenarios();
    }, [tag]);

    if (isLoading) {
        return <div className={styles.centeredContainer}><Loading/></div>;
    }

    return (
        <div className={styles.browsePageContainer}>
            <h1 className={styles.browsePageTitle}>
                Scenarios tagged with "<span className={styles.tagTerm}>{tag}</span>"
            </h1>
            {scenarios && scenarios.length > 0 ? (
                <div className={styles.resultsGrid}>
                    {scenarios.map((scenario) => (
                        <ScenarioCard key={scenario._id} scenario={scenario} />
                    ))}
                </div>
            ) : (
                <div className={styles.noResultsContainer}>
                    <p className={styles.noResultsMessage}>
                        No scenarios found for the tag "<span className={styles.tagTerm}>{tag}</span>".
                    </p>
                     <p className={styles.noResultsSuggestion}>
                        Try exploring other tags or searching directly.
                    </p>
                </div>
            )}
        </div>
    );
};

export default Browse;
